import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { billingQKeys } from "@hooks/queries/billing/queryKeys";
import { followUpQKeys } from "@hooks/queries/followUp/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { BillTransaction } from "@customTypes/billing";


interface MutationProps {
  billId: string;
  transaction: Partial<BillTransaction>;
}

export const useCreateTransaction = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: ({ billId, transaction }: MutationProps) => {
      // import.meta.env.DEV && console.log("transaction:", transaction);
      return api.post(`billing/add-transaction/${billId}`, {
        payment_method: transaction.paymentMethod,
        amount_paid: transaction.amountPaid,
      });
    },
    onSuccess: res => {
      // import.meta.env.DEV && console.log(res.data);
      showSuccessNotification({
        title: "success",
        message: "create-transaction-success",
      });
      queryClient.invalidateQueries({
        queryKey: billingQKeys.consultation(res.data.consultation_id),
      });
      queryClient.invalidateQueries({
        queryKey: followUpQKeys.all(),
      });
    },

    onError: (res: any) => {
      console.error("[From Create Transaction]", res);

      handleErrors(res, "mutation");
    },
  });
};
